import React from 'react';
import { Box, Typography, Chip, Stack } from '@mui/material';
import { diffInDays } from '../../utilis/date';

// Helper function to convert alert type values to readable labels
const getAlertTypeLabel = (typeValue) => {
    const typeLabels = {
        'weeks': 'Weekly',
        'biWeeks': 'Bi-Weekly', 
        'months': 'Monthly'
    };
    return typeLabels[typeValue] || typeValue;
};

const ReportHistoryDisplay = ({ description, isActive = false, type = null, alertReport = null }) => {
    // Try to parse the description as JSON, fallback to text
    let richData = null;
    let isRichFormat = false;
    
    try {
        if (description && typeof description === 'string' && description.startsWith('{')) {
            richData = JSON.parse(description);
            isRichFormat = true;
        }
    } catch (error) {
        // If parsing fails, treat as plain text
        isRichFormat = false;
    }

    // If it's not rich format, display as simple text
    if (!isRichFormat || !richData) {
        return (
            <Box>
                <Typography variant="body2" color="text.secondary">
                    {description || 'No description available'}
                </Typography>
            </Box>
        );
    }

    const { reportConfig, filterChips = [], additionalOptions = [] } = richData;

    return (
        <Box sx={{ mt: 1 }}>
            {/* Report Configuration Header */}
            <Typography
                variant="subtitle2"
                sx={{
                    fontWeight: 600,
                    mb: 1.5,
                    color: '#1976d2'
                }}
            >
                📊 Report Configuration
            </Typography>

            {/* Basic Description */}
            {/* <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                {richData.description}
            </Typography> */}

            {/* Report Details as Chips */}
            <Stack direction="row" spacing={1} flexWrap="wrap" sx={{ mb: 2 }}>
                {reportConfig?.interval && type === 'REPORT' && (
                    <Chip
                        label={`Interval: ${reportConfig.interval}`}
                        size="small"
                        variant="outlined"
                        sx={{
                            backgroundColor: '#e3f2fd',
                            borderColor: '#2196f3'
                        }}
                    />
                )}
                {reportConfig?.type && type === 'ALERT' && (
                    <Chip
                        label={`Alert Frequency: ${alertReport?.type?.map(getAlertTypeLabel).join(', ')}`}
                        size="small"
                        variant="outlined"
                        sx={{
                            backgroundColor: '#e3f2fd',
                            borderColor: '#2196f3'
                        }}
                    />
                )}


                {reportConfig?.pageType && (
                    <Chip
                        label={`Page: ${reportConfig.pageType}`}
                        size="small"
                        variant="outlined"
                        sx={{
                            backgroundColor: '#f3e5f5',
                            borderColor: '#9c27b0'
                        }}
                    />
                )}
                {/* {reportConfig?.reportFileType && (
                    <Chip 
                        label={`Format: ${reportConfig.reportFileType}`} 
                        size="small" 
                        variant="outlined"
                        sx={{ 
                            backgroundColor: '#e8f5e8',
                            borderColor: '#4caf50'
                        }}
                    />
                )} */}
                <Chip
                    label={isActive ? 'Active' : 'Inactive'}
                    size="small"
                    variant="filled"
                    sx={{
                        backgroundColor: isActive ? '#4caf50' : '#f44336',
                        color: 'white'
                    }}
                />
            </Stack>

            {/* Active Filters */}
            {filterChips.length > 0 && (
                <Box sx={{ mb: 2 }}>
                    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
                        Active Filters:
                    </Typography>
                    <Stack direction="row" spacing={0.5} flexWrap="wrap">
                        {filterChips.map((chip, index) => (
                            <Chip
                                key={index}
                                label={chip.label}
                                size="small"
                                variant="outlined"
                                sx={{
                                    fontSize: '0.7rem',
                                    height: '22px',
                                    mb: 0.5,
                                    ...(chip.isLocked && {
                                        border: '2px solid #ffc107',
                                        boxShadow: '0 0 8px rgba(255, 193, 7, 0.3)',
                                        backgroundColor: 'rgba(255, 193, 7, 0.1)'
                                    })
                                }}
                            />
                        ))}
                    </Stack>
                </Box>
            )}

            {/* Additional Options */}
            {additionalOptions.length > 0 && (
                <Box>
                    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
                        Additional Options:
                    </Typography>
                    <Stack direction="row" spacing={0.5} flexWrap="wrap">
                        {additionalOptions.map((option, index) => (
                            <Chip
                                key={index}
                                label={option.label}
                                size="small"
                                variant="filled"
                                sx={{
                                    fontSize: '0.7rem',
                                    height: '22px',
                                    mb: 0.5,
                                    backgroundColor: '#ff9800',
                                    color: 'white'
                                }}
                            />
                        ))}
                    </Stack>
                </Box>
            )}

            {/* Timestamp */}
            {richData.metadata?.createdAt && (
                <Typography variant="caption" color="text.disabled" sx={{ display: 'block', mt: 1, fontStyle: 'italic' }}>
                    Configured {(() => {
                        const days = diffInDays(new Date(), richData.metadata.createdAt);
                        if (!Number.isFinite(days) || days < 0) return 'recently';
                        if (days === 0) return 'today';
                        if (days === 1) return '1 day ago';
                        return `${days} days ago`;
                    })()}
                </Typography>
            )}
        </Box>
    );
};

export default ReportHistoryDisplay; 